import { WsClient } from '@rammetec/core/ws-client';
export function connectSystemApi(options) {
    const wsClientOptions = {
        url: `${options.host}/ws/session`,
        getToken: options.getToken,
        sessionInfo: {
            sessionId: options.sessionId,
            sessionHash: options.sessionHash,
            platform: options.platform,
            environment: options.isDev ? 'development' : 'production',
        },
    };
    const client = new WsClient(wsClientOptions);
    client.connect();
    return client;
}
//# sourceMappingURL=connectSystemApi.js.map